import * as React from 'react';
import './AppFooter.css';

class AppFooter extends React.Component {
  public render () {
    return (
      <div className="AppFooter">
        <div className="container">
          <p>By Ginpei.</p>
        </div>
      </div>
    );
  }
}

export default AppFooter;



// WEBPACK FOOTER //
// ./src/components/AppFooter.tsx